import Content from '../../content.js';

var Export = Content.extend({
  render: function () {
    var checkboxSelector = '.csv-checkbox';

    $('#select-exported-fields-btn').off();
    $('#select-exported-fields-btn').on(
      'click',
      function () {
        if (this.selectCsvFieldsModal) {
          this.selectCsvFieldsModal.close();
        }
      }.bind(this),
    );

    this._monitorSection('#all-selected', checkboxSelector);
    this._monitorSection('#store-all-selected', '.store-header');
    this._monitorSection('#ajb-all-selected', '.ajb-header');
    this._monitorSection('#esocket-all-selected', '.esocket-header');
    this._monitorSection('#engage-all-selected', '.engage-header');
    this._monitorSection('#device-all-selected', '.device-header');

    $(checkboxSelector).off();
    $(checkboxSelector).on(
      'change',
      function (e) {
        var section = $(e.target).data('section'),
          sectionChecked = !$('#' + section + '-all-selected').is(':checked');

        if (!$(e.target).prop('checked')) {
          this._toogleCheckbox($('#all-selected-container'), 'disable');

          if (
            $(e.target)
              .attr('id')
              .match(/all-selected/) === null
          ) {
            this._toogleCheckbox($('.' + section + '-section'), 'disable');
          }
        }

        if ($('.alone-checkbox :checked').length > 0) {
          $('#select-exported-fields-btn').removeClass('disabled');
        } else {
          $('#select-exported-fields-btn').addClass('disabled');
        }

        if (
          $('.alone-checkbox :checked').length == $('.alone-checkbox').length &&
          !$('#all-selected').is(':checked')
        ) {
          $('#all-selected').prop('checked', true);
        }

        if (
          $('.' + section + '-header :checked').length ==
            $('.' + section + '-header').length &&
          sectionChecked
        ) {
          $('#' + section + '-all-selected').prop('checked', true);
        }
      }.bind(this),
    );

    // It is used for CSV export feature set the timezone code
    $('#timezone').val(moment.tz(moment.tz.guess()).format('z'));
  },

  _toogleCheckbox: function (element, action) {
    if (action === 'disable') {
      element.find('input').prop('checked', false);
      element.find('span').removeClass('checked');
    } else if (action === 'enable') {
      element.find('input').prop('checked', true);
      element.find('span').addClass('checked');
    }
  },

  _monitorSection: function (fieldId, childrenSelector) {
    $(fieldId).off();
    $(fieldId).on('change', function (evt) {
      if ($(evt.target).prop('checked')) {
        $(childrenSelector).each(function () {
          $(this).find('input').prop('checked', true);
          $(this).find('span').addClass('checked');
          $('#select-exported-fields-btn').removeClass('disabled');
        });
      } else {
        $(childrenSelector).each(function () {
          $(this).find('input').prop('checked', false);
          $(this).find('span').removeClass('checked');
          if ($('.alone-checkbox').find('input:checked').length === 0) {
            $('#select-exported-fields-btn').addClass('disabled');
          }
        });
      }
    });
  },
});

module.exports = Export;
